import { render, staticRenderFns } from "./NewIdChartPerfomanceComparison.vue?vue&type=template&id=e0df8664&scoped=true"
import script from "./NewIdChartPerfomanceComparison.vue?vue&type=script&lang=js"
export * from "./NewIdChartPerfomanceComparison.vue?vue&type=script&lang=js"
import style0 from "./NewIdChartPerfomanceComparison.vue?vue&type=style&index=0&id=e0df8664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0df8664",
  null
  
)

export default component.exports